import { render, staticRenderFns } from "./letter-add.vue?vue&type=template&id=da0a8794&"
import script from "./letter-add.vue?vue&type=script&lang=js&"
export * from "./letter-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports